export enum PromoCodeNumberOfUseType {
  SingleUse = 'SINGLE_USE',
  OncePerDay = 'ONCE_PER_DAY',
  UnlimitedUse = 'UNLIMITED_USE',
  CustomUse = 'CUSTOM_USE'
}
